import { render, staticRenderFns } from "./GetOXml.vue?vue&type=template&id=479a6b2c&"
import script from "./GetOXml.vue?vue&type=script&lang=js&"
export * from "./GetOXml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports